import { defaultTFormV2 } from "../models/TForm";
import * as ProbateCase2 from "../../../domain/models/ProbateCase2";
import * as ProbateCase1 from "../../../domain/models/ProbateCase1";
import { TProbateCase1AndC2From, TProbateCase2ReadOnlyFrom } from "./../models/TFormModels";

export class C {
    caseForm: TProbateCase1AndC2From = defaultTFormV2(ProbateCase2.newDefault(), ProbateCase1.newDefault(), {});
    viewCaseForm: TProbateCase2ReadOnlyFrom = defaultTFormV2(ProbateCase2.newDefault(), {}, {});
}
